export default "__VITE_ASSET__89c310fc__"